import { View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout } from "@pimo/pimo-components/src/lib/layouts/drag-and-drop-layout/drag-and-drop-layout";
import {
  PMBarChartCard,
  PMDonutChartCard,
} from "@pimo/pimo-components/src/lib/pm-components";

import { TestAppState } from "../../../app";
import { DONUT_CARD_LAYOUT } from "../../../constants";
import {
  getAllReportingItems,
  getArrayFieldData,
  withTotalInTitle,
} from "../../../helpers/pages-helpers/dashboard-plugin-helpers";

/**
 * The bar and donut chart pair showing systems per capability (#2222) —
 * hand-duplicated copies of the same data before this split.
 */
export function addCapabilityChartsCard(
  view: View<TestAppState, DragAndDropLayout>
): void {
  const capabilitiesBarChartComponent = view.addComponent({
    component: PMBarChartCard,
    layoutProps: {
      componentId: "capabilitiesDashboardBarChartComponent",
      labels: ["barChart", "chart", "capability"],
      description: "Shows systems grouped by capability across all projects.",
      title: "Systems per Capability",
    },
  });

  capabilitiesBarChartComponent.mapState(({ dashboard }) => {
    const allItems = getAllReportingItems(dashboard);
    const { entries } = getArrayFieldData(
      allItems,
      (item) => item.basicItem?.applicationCapabilities
    );

    return {
      title: "Systems per Capability",
      categories: entries.map((entry) => entry.label),
      data: entries.map((entry) => entry.count),
      chartType: 1 as const,
      xLabel: "Systems",
      yLabel: "Capability",
      colors: entries.map((entry) => entry.color),
      fixedHeight: "320px",
    };
  });

  const capabilitiesDonutChartComponent = view.addComponent({
    component: PMDonutChartCard,
    layoutProps: {
      componentId: "capabilitiesDashboardDonutChartComponent",
      labels: ["donutChart", "chart", "capability"],
      description: "Shows systems grouped by capability across all projects.",
      title: "Systems per Capability ",
    },
  });

  capabilitiesDonutChartComponent.mapState(({ dashboard }) => {
    const allItems = getAllReportingItems(dashboard);
    const { entries } = getArrayFieldData(
      allItems,
      (item) => item.basicItem?.applicationCapabilities
    );

    return {
      title: withTotalInTitle("Systems per Capability", allItems.length),
      icon: "DonutLarge",
      ...DONUT_CARD_LAYOUT,
      data: entries.map((entry) => ({
        label: entry.label,
        value: entry.count,
        color: entry.color,
      })),
    };
  });
}
